import _objectSpread from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
function $93925083ecbb358c$export$48d1ea6320830260(handler) {
  if (!handler) return undefined;
  var shouldStopPropagation = true;
  return function (e) {
    var event = _objectSpread({}, e, {
      preventDefault: function preventDefault() {
        e.preventDefault();
      },
      isDefaultPrevented: function isDefaultPrevented() {
        return e.isDefaultPrevented();
      },
      stopPropagation: function stopPropagation() {
        console.error('stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.');
      },
      continuePropagation: function continuePropagation() {
        shouldStopPropagation = false;
      }
    });
    handler(event);
    if (shouldStopPropagation) e.stopPropagation();
  };
}
export { $93925083ecbb358c$export$48d1ea6320830260 as createEventHandler };